import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import React from 'react';
import {
  Button,
  Dialog as DialogComponent,
  Divider,
  Text,
} from 'wix-ui-tpa/cssVars';
import { useCalendarActions } from '../../../Hooks/useCalendarActions';
import { RescheduleSuccessDialogViewModel } from '../../../ViewModel/dialogViewModel/dialogViewModel';
import { DataHooks } from './constants';
import { classes, st } from './RescheduleSuccessDialog.st.css';

export type RescheduleSuccessDialogProps = {
  viewModel: RescheduleSuccessDialogViewModel;
};

export const RescheduleSuccessDialog = ({
  viewModel,
}: RescheduleSuccessDialogProps) => {
  const { onRescheduleSuccessDialogNavigate } = useCalendarActions();
  const { isMobile } = useEnvironment();
  const { t } = useTranslation();
  const { isOpen, data } = viewModel;
  const {
    titleText,
    serviceName,
    dateTime,
    staffMember,
    location,
    participantsCount,
    confirmButtonText,
  } = data;

  return (
    <DialogComponent
      data-hook={DataHooks.Root}
      isOpen={isOpen}
      className={st(classes.root, { isMobile })}
      contentClassName={classes.dialogContent}
      notFullscreenOnMobile
    >
      <Text className={classes.title} data-hook={DataHooks.Title}>
        {titleText}
      </Text>

      <Divider className={classes.divider} />

      <div className={classes.details}>
        <Text className={classes.detailText} data-hook={DataHooks.ServiceName}>
          {serviceName}
        </Text>
        <Text className={classes.detailText} data-hook={DataHooks.DateTime}>
          {dateTime}
        </Text>
        {staffMember && (
          <Text
            className={classes.detailText}
            data-hook={DataHooks.StaffMember}
          >
            {t('app.rescheduled-booking.success.dialog.with-staff', {
              staffMember,
            })}
          </Text>
        )}
        {location && (
          <Text className={classes.detailText} data-hook={DataHooks.Location}>
            {t('app.rescheduled-booking.success.dialog.location', { location })}
          </Text>
        )}
        <Text className={classes.detailText} data-hook={DataHooks.Participants}>
          {t('app.rescheduled-booking.success.dialog.participants', {
            count: participantsCount,
          })}
        </Text>
      </div>

      <Divider className={classes.divider} />

      <Button
        upgrade
        data-hook={DataHooks.ConfirmButton}
        className={classes.button}
        onClick={() => onRescheduleSuccessDialogNavigate()}
        fullWidth={isMobile}
      >
        {confirmButtonText}
      </Button>
    </DialogComponent>
  );
};
